export const STORAGE_KEY = "cart-storage-v2";
